import { Link } from "react-router-dom";
import { IProfile } from "../../../models/profile.model";
import { profileActions } from "../../../store/profileSlice";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { exportJson } from "../../../utils";
import MainLayout from "../../layouts/main-layout/MainLayout";
import ActionIcon from "../../ui/action-icon/ActionIcon";
import TitleBox from "../../ui/title-box/TitleBox";
import "./ProfileManagerPage.scss";
import ProfileCard from "./components/profile-card/ProfileCard";
import ItemType from "../../../enums/itemType.enum";
import { socketActions } from "../../../store/socketSlice";

const ProfileManagerPage = () => {
  const profiles = useAppSelector((s) => s.profile.profiles);

  const exportAllProfiles = () => {
    exportJson(profiles, "profile_dump");
  };

  const dispatch = useAppDispatch();

  const deleteProfile = (profile: IProfile) => {
    const proceed = window.confirm(
      `Do you really want to delete the profile '${profile.name}'?`
    );
    if (proceed) {
      dispatch(profileActions.removeProfileByName(profile.name));
    }
  };

  const exportProfile = (profile: IProfile) => {
    exportJson(profile, profile.name);
  };

  const spawnProfile = (p: IProfile) => {
    const spawnCommands: string[] = [];

    p.items.forEach((stack) => {
      const cmd =
        stack.type === ItemType.Weapon
          ? "spawnWeapon"
          : stack.type === ItemType.Magazine
          ? "spawnMagazine"
          : stack.type === ItemType.Backpack
          ? "spawnBackpack"
          : undefined;

      if (cmd !== undefined) {
        spawnCommands.push(`${cmd} ${stack.classname} ${stack.amount};`);
      }
    });

    if (spawnCommands.length > 0) {
      dispatch(socketActions.sendMessage(spawnCommands.join("\n")));
    } else {
      console.log("no valid spawn commands found");
    }
  };

  return (
    <MainLayout>
      <div className="profile-manager-page">
        <TitleBox title="Profile manager">
          {profiles.length > 0 && (
            <ActionIcon
              icon={"fa-solid fa-download"}
              onClick={exportAllProfiles}
            />
          )}
        </TitleBox>
        <div className="existing-profiles">
          {profiles.map((p, i) => {
            return (
              <ProfileCard profile={p} key={i}>
                <ActionIcon
                  icon="fa-solid fa-circle-play"
                  onClick={() => spawnProfile(p)}
                />
                <ActionIcon
                  icon={"fa-solid fa-download"}
                  onClick={() => exportProfile(p)}
                />
                <ActionIcon
                  icon={"fa-solid fa-trash-can"}
                  onClick={() => deleteProfile(p)}
                />
              </ProfileCard>
            );
          })}
          {profiles.length === 0 && (
            <p>
              It seems like there are currently no spawn profiles saved. You can
              create profiles <Link to={"/item-database"}>here</Link>.
            </p>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default ProfileManagerPage;
